import { FC } from 'react';
import { Info } from 'lucide-react';

interface InfoProps {
  text: string;
  textClassName?: string;
}

const Information: FC<InfoProps> = ({ text, textClassName }) => {
  return (
    <div className="flex p-5 items-center gap-3 rounded-lg bg-(--primary-O200)/50">
      <Info size={20} className="text-(--warning-W700)" />
      <p
        className={`text-(--primary-O900)! [font-family:var(--font-montserrat)] font-semibold leading-[150%] m-0! ${textClassName ?? '[font-size:var(--fs-p3)]'}`}
      >
        {text}
      </p>
    </div>
  );
};

export default Information;
